module.exports = __webpack_public_path__ + "static/media/dwellPass-logo-beta-white-800w.f8cde0e8.png";